var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-container"},[(_vm.checkHasImage())?_c('div',{staticClass:"content-image"},[_c('img',{attrs:{"src":_vm.mainImage}})]):_vm._e(),_c('p',{staticClass:"content-text app-content-wrap",class:{'content-text--without-content-image': !_vm.checkHasImage() }},[_c(_vm.processedHtml,{tag:"component"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }